export const SET_SHIPPING = (state, data) => {
    state.methods = data;
};

export const SET_LOADER = (state, data) => {
    state.loader = data;
};
